import { Component, OnDestroy, OnInit } from '@angular/core';

import { DEPARTMENT_PATH_COACHTRAINING, DEPARTMENT_TYPE_COACHTRAINING } from '@core/constants';
import { SharedSidebarService } from '@theme/components';
import { Title } from '@angular/platform-browser';
import { SetupService } from '@core/services/setup';

@Component({
    selector: 'app-coachtraining',
    templateUrl: './coachtraining.component.html',
    styleUrls: ['./coachtraining.component.scss'],
})
export class CoachtrainingComponent implements OnInit, OnDestroy {
    /**
     * Definição da identificão da sessão/depto Capacitação
     */
    public departmentType: string = DEPARTMENT_TYPE_COACHTRAINING;

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any;
    overviewImage: string;

    constructor(
        private sharedSidebarService: SharedSidebarService,
        private title: Title,
        private setupService: SetupService
    ) {}

    ngOnInit(): void {
        this.sideMenu();
        this.title.setTitle(`Capacitação - ${this.setupService.title}`);
        this.overviewImage = this.setupService.images?.header?.coachtraining;
        this.setupService.setFooterImageFromDepartment(DEPARTMENT_PATH_COACHTRAINING);
    }

    sideMenu() {
        this.sharedSidebarService.getSideMenu(this.departmentType).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
    }

    ngOnDestroy(): void {
        this.setupService.setFooterImage();
    }
}
